import React from 'react';
import PropTypes from 'prop-types';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';

import { UserStore } from 'four-nets/user/user';
import { CategoryStore } from 'four-nets/forum/forum';
import ErrorPage from 'four-nets/errors/error-page';
import { Site } from 'four-nets/site';

import ThreadView, { ThreadViewModel } from './thread-view';

class ThreadLoader extends React.PureComponent {
    static contextTypes = {
        api: PropTypes.object,
        app: PropTypes.object,
        categoryStore: PropTypes.instanceOf(CategoryStore),
        site: PropTypes.object,
        userStore: PropTypes.instanceOf(UserStore),
    };

    constructor(props, context) {
        super(props, context);

        this.dataSource = {
            userStore: this.context.userStore,
            mailStore: this.context.userStore.mailStore,
            categoryStore: this.context.categoryStore,
            threadStore: this.context.categoryStore.threadStore,
        };
    }

    transform = data => {
        const threadViewModel = new ThreadViewModel(this.dataSource, this.props.match.params);
        threadViewModel.fromJSON(data.threadViewModel);

        return {
            threadViewModel,
        };
    };

    fetch = (setData, props) => {
        const threadViewModel = new ThreadViewModel(this.dataSource, props);
        threadViewModel.params = props;

        return threadViewModel.load().then(() => {
            setData({ threadViewModel }, false);
        });
    };

    renderFetch = ({ loading, error, data }) => {
        const { page, desc, post } = this.props.search || {};

        if (data && data.threadViewModel && data.threadViewModel.thread) {
            const { site } = this.context;
            const { location } = this.props;
            const { server } = data.threadViewModel.thread;

            if (site.id !== server && typeof window !== 'undefined') {
                window.location.href = `${Site.getUrl(server)}${location.pathname}`;
            }
        }

        return (
            <LoadingProgress loading={loading}>
                <ErrorPage error={error}>
                    {data ? (
                        <ThreadView threadViewModel={data.threadViewModel} page={page} desc={desc} post={post} />
                    ) : null}
                </ErrorPage>
            </LoadingProgress>
        );
    };

    render() {
        const { category, slug } = this.props.match.params;

        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                render={this.renderFetch}
                transform={this.transform}
                category={category}
                slug={slug}
            />
        );
    }
}

export default ThreadLoader;
